<template>
    <div class="container">

      <h2 style="color: black;">🐾  🐾 </h2>
      <div style="background-color: white; padding: 20px; border-radius: 10px;">
        <img :src="require('@/assets/cat-confetti.gif')" alt="Cat Confetti" width="250" height="250" />
        <h2>StingyCat's Purr-fect Credit Score Estimator</h2>
  
        <form @submit.prevent="calculateEstimate">
      <label>
        Total Credit Card Balances:
        <input type="number" v-model="balances" />
      </label>
      <label>
        Number of Late Payments:
        <input type="number" v-model="latePayments" />
      </label>
      <!-- Add more fields here -->

      <button type="submit">Estimate My Score</button>
    </form>
    <div v-if="estimatedScore">
      <h3>Your Estimated Credit Score: {{ estimatedScore }}</h3>
    </div>
  </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const balances = ref(0);
const latePayments = ref(0);
const estimatedScore = ref(null);

const calculateEstimate = () => {
  // Perform calculations based on the inputs to estimate the credit score
  // This is a placeholder; replace with your actual logic
  estimatedScore.value = 700 - latePayments.value * 10 + balances.value * 0.01;
};
</script>        

<style scoped>
.container {
  background-color: #4A148C;
  color: black;
  padding: 20px;
  border-radius: 20px;
}

.credit-estimator {
  background-color: #f4f4f4;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
}
.content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  color: black;
}
</style>